export default "__VITE_ASSET__D3g9gWd6__";